/**
 * The jet's living details (GDD §3.6): flickering afterburner cones with glow and a blinking tail strobe
 * (concept L1304–L1309). Pure functions of the clock.
 */
import { fract } from '../core/math.ts';

/** Length scale of the outer (even index) and inner (odd index, ×1.1) afterburner cones. */
export function flameScale(t: number, index: number): number {
  const f = 0.85 + 0.25 * Math.sin(t * 60) + 0.1 * Math.sin(t * 23);
  return f * (index % 2 ? 1.1 : 1);
}

export function glowScale(t: number): number {
  return 4.6 + Math.sin(t * 50) * 0.6;
}

export function strobeOn(t: number): boolean {
  return fract(t * 0.9) < 0.08;
}
